export default __webpack_public_path__ + "static/media/thumbnail.97f2ac10.png";